import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { eventAPI } from '../services/api';

function Dashboard() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const eventsRes = await eventAPI.getAll();
      // Handle array or object response
      const eventsData = Array.isArray(eventsRes.data) ? eventsRes.data : [];
      setEvents(eventsData);
    } catch (err) {
      setError('Failed to load events data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) return <div className="loading">Loading dashboard...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="dashboard">
      <h1 className="dashboard-header">Events Dashboard</h1>
      
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Events</div>
          <div className="stat-value">{events.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Active Events</div>
          <div className="stat-value">{events.filter(e => e.is_active !== false).length}</div>
        </div>
      </div>

      <div className="events-section">
        <h2>Available Events</h2>
        <div className="events-grid">
          {events.map(event => (
            <div 
              key={event.id || event.event_id} 
              className="event-card"
              onClick={() => navigate(`/event/${event.id || event.event_id}`)}
            >
              <div className="event-name">{event.name || event.event_name}</div>
              <div className="event-info">📅 {event.start_time ? formatDate(event.start_time) : 'Date TBD'}</div>
              <div className="event-info">📍 {event.venue_name || event.location || 'TBD'}</div>
              <div className="event-info">
                {event.description ? event.description.substring(0, 100) + '...' : 'No description available'}
              </div>
              
              {event.ticket_types && Array.isArray(event.ticket_types) && (
                <div className="ticket-types">
                  {event.ticket_types.map((ticket, index) => (
                    <div key={ticket.id || index} className="ticket-type">
                      <span className={`ticket-badge ${(ticket.type || '').toLowerCase()}`}>
                        {ticket.type || 'Ticket'}
                      </span>
                      <span>
                        {ticket.available_quantity}/{ticket.total_quantity} @ {formatCurrency(ticket.price || 0)}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;